import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import "../../../App.css"

const PaginationControls = ({
  totalEntries,
  rowsPerPage,
  setRowsPerPage,
  currentPage,
  setCurrentPage,
  handlePageChange,
}) => {
  const { t, i18n } = useTranslation();
  const totalPages = Math.ceil(totalEntries / rowsPerPage);
  const startEntry = (currentPage - 1) * rowsPerPage + 1;
  const endEntry = Math.min(currentPage * rowsPerPage, totalEntries);
  const isRTL = i18n.dir() === "rtl";

  return (
    <div
      className={`d-flex justify-content-end align-items-center mt-3 text-center ${isRTL ? "rtl-flip" : ""}`}
      style={{ width: "99%" }}
    >
      {/* Rows per Page Dropdown */}
      <span className={`${isRTL ? "ms-2" : "me-2"} text-muted`}>
        {t("RowsPerPage")}
      </span>
      <select
        className={`form-select form-select-sm ${isRTL ? "ms-3" : "me-3"}`}
        style={{ width: "70px" }}
        value={rowsPerPage}
        onChange={(e) => {
          setRowsPerPage(Number(e.target.value));
          setCurrentPage(1);
        }}
      >
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>

      {/* Showing Entries Info */}
      <span className={`${isRTL ? "ms-3" : "me-3"} text-muted`}>
        <span style={{ unicodeBidi: "isolate", direction: "ltr" }}>
          {startEntry} - {endEntry}
        </span>{" "}
        {t("of")}{" "}
        <span style={{ unicodeBidi: "isolate", direction: "ltr" }}>
          {totalEntries}
        </span>
      </span>


      {/* Pagination Buttons */}
      <button
        className={`${isRTL ? "ms-1" : "me-1"} btn btn-sm btn-light`}
        disabled={currentPage === 1}
        onClick={() => handlePageChange(1)}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" /><path fill="none" d="M24 24H0V0h24v24z" /></svg>
      </button>
      <button
        className={`${isRTL ? "ms-1" : "me-1"} btn btn-sm btn-light`}
        disabled={currentPage === 1}
        onClick={() => handlePageChange(currentPage - 1)}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" /><path d="M0 0h24v24H0z" fill="none" /></svg>
      </button>
      <button
        className={`${isRTL ? "ms-1" : "me-1"} btn btn-sm btn-light`}
        disabled={currentPage === totalPages}
        onClick={() => handlePageChange(currentPage + 1)}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" /><path d="M0 0h24v24H0z" fill="none" /></svg>
      </button>
      <button
        className="btn btn-sm btn-light"
        disabled={currentPage === totalPages}
        onClick={() => handlePageChange(totalPages)}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" /><path fill="none" d="M0 0h24v24H0V0z" /></svg>
      </button>
    </div>
  );
};

export default React.memo(PaginationControls);
